import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  EditContactPlanRequestDto
} from '../../../../_models/messaging/automation/contact-plans/edit-contact-plan-request-dto';
import { ExecutionResultDto } from '../../../../_models/execution-result-model';
import { ExecutionResult } from '../../../../_models/execution-result-enum';
import {
  ContactPlanGridRecordDto
} from '../../../../_models/messaging/automation/contact-plans/contact-plan-grid-record-dto';
import { ContactPlanService } from '../../../../_services/messaging/automation/contact-plan.service';
import { NotificationService } from '../../../../_services/notification.service';

@Component({
  selector: 'app-unsaved-changes',
  templateUrl: './inactivity-warning-modal.component.html',
  styleUrls: ['./inactivity-warning-modal.component.scss']
})
export class InactivityWarningModalComponent implements OnInit {
  title = 'Inactivity Warning';
  action: string;

  constructor(    
    public dialogRef: MatDialogRef<InactivityWarningModalComponent>   
  ) { }

  ngOnInit(): void {  
  }

  confirm() {
    this.dialogRef.close(true);
  }
}
